import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@easyfo/common-lib';

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.css"],
})
export class NotFoundComponent {
  constructor(
    private titleService: Title,
    private _authService: AuthService) {
    this.titleService.setTitle("Page Not Found");
    this.isLogin = this._authService.isLogin();
  }
  isLogin: any = false;

}
